
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stage-rental",
      function () {
        return require("private-next-pages/stage-rental.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stage-rental"])
      });
    }
  